const text2Html=(text='')=>{
  const ret=text.replace(/\n/g,'<br />');
  return {__html:ret}
}

export {
  text2Html
}